declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../services/spinner.service';
import { AppData } from '../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCService } from '../../../../../services/doc.service';
import { DownloadFileRequest } from '../../../../../models/docs/doc.model';
import { ActorIdentitiesRequest, ActorDocRequest, ActorDocController, SaveCounsellingPlanRequest, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, CounsellingPlanRequest, CounsellingPlanController } from '../../../../../models/actor/actor';
import { ActorService } from '../../../../../services/actor.service';
import { DBOperation } from '../../../../../enums/enum';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../../shared/services/toastr.service';

@Component({
  selector: 'editcounsellingplan',
  templateUrl: './editcounsellingplan.modal.html',
  styleUrls: ['./editcounsellingplan.modal.scss']
})

export class NgbEditCounsellingPlanModal implements OnInit {


  @Input() ActorDocCode;
  @Input() DownloadActorImageFileExtension: string;
  @Input() DownloadActorImageFile: string;
  @Input() FormattedCode: string;
  @Input() FacilityShortName: string;
  @Input() CurrentEditCounsellingPlanRequest: SaveCounsellingPlanRequest;
  @Input() CanEdit: number;
  @Input() CanShow: number;

  DOB: NgbDateStruct;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;

  StartDate: NgbDateStruct;
  EndDate: NgbDateStruct;
  RecommendedPackage: string;
  Doctor: string;
  PackageCost: number;
  SelectEmi: boolean;
  ActorCode: number;
  Concerns: string;
  AddRemarks: string;
  file: File;
  fileList: FileList;



  FileExtension: string = "";
  MaritalStatus: string;
  JobType: string;
  public isRequesting: boolean = false;
  public ShowList: boolean = true;
  public isEdit: boolean = false;
  public ApiResData: ApiResponseModel;
  public ApiReqData: ApiRequestModel
  private modalRef: NgbModalRef;
  public isvisible = true;
  DocFriendlyName: string = "";
  

  //CurrentSaveCounsellingPlanRequest: SaveCounsellingPlanRequest;
  
 
  CurrentActorDocController: ActorDocController[];

  @ViewChild('f') IdentitiesForm: NgForm;
  public UploadActorDoc: any;

  public CanDownLoadActorDoc: number

  public CanNurseView: number =0 ;
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;
  LoadPatients() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
    //alert(this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode);
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";

    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPatientInfoByFormattedCodeController();
  }
  SelectedPatient: PatientInfoByFormattedCodeController;
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private docservice: DOCService,
    private router: Router, private route: ActivatedRoute, private actorservice: ActorService, private tosterservice: NGXToastrService, private parserFormatter: NgbDateParserFormatter) { }
  ngOnInit() {
    this.LoadPatients();
    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    //this.CurrentEditCounsellingPlanRequest = new SaveCounsellingPlanRequest();
    //this.CurrentEditCounsellingPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    if (this.CurrentEditCounsellingPlanRequest.StartDate != null) {
      var SValidFrom = new Date(this.CurrentEditCounsellingPlanRequest.StartDate);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.StartDate >1990');
        this.StartDate = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }
    if (this.CurrentEditCounsellingPlanRequest.EndDate != null) {
      var SValidTo = new Date(this.CurrentEditCounsellingPlanRequest.EndDate);
      if (SValidTo.getFullYear() > 1900) {
        console.log('this.EndDate >1990');
        this.EndDate = {

          year: SValidTo.getFullYear(),
          month: SValidTo.getMonth() + 1,
          day: SValidTo.getDate()
        }
      }
    }
  }
  


 
  onSubmit() {
     this.isvisible = false;
    this.CurrentEditCounsellingPlanRequest.StartDate = new Date(this.parserFormatter.format(this.StartDate));
    this.CurrentEditCounsellingPlanRequest.EndDate = new Date(this.parserFormatter.format(this.EndDate));
    //this.CurrentEditCounsellingPlanRequest.ActorCode = this.ActorCode.toString();
    this.CurrentEditCounsellingPlanRequest.ConditionalOperator = 20;
    this.CurrentEditCounsellingPlanRequest.Remarks = "";
    this.CurrentEditCounsellingPlanRequest.VisitCode = "";
    this.CurrentEditCounsellingPlanRequest.CreatedUser = AppData.Instance().UserLoginDetails.DisplayName;


    this.actorservice.SaveCounsellingPlan(this.CurrentEditCounsellingPlanRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  
private stopRefreshing() {
  this.loaderService.displayLoader(false);
  this.isRequesting = false;
}
  private StartRefreshing() {
  this.loaderService.displayLoader(true);
  this.isRequesting = true;
  }
  editfollicular() {
    this.router.navigate(['nurse/editfollicular']);
    this.activeModal.close();
  }
  //edit(EditCounsellingplanController: CounsellingPlanController) {
  //  this.ShowList = false;
  //  this.isEdit = true;
  //  this.CurrentEditCounsellingPalnRequest.PlanStatus = EditCounsellingplanController.PlanStatus;
  //  this.CurrentEditCounsellingPalnRequest.TreatmentPlan = EditCounsellingplanController.TreatmentPlan;
  //  this.CurrentEditCounsellingPalnRequest.StartDate = EditCounsellingplanController.StartDate;
    
  //}
  back() {
    this.ShowList = true;
    this.isEdit = false;
  }
  //onEditSubmit() {
    
  //    //this.CurrentSaveCounsellingPlanRequest.CounsellingPlanCode = this.MaritalStatus;
  //  this.CurrentEditCounsellingPalnRequest.StartDate = new Date(this.parserFormatter.format(this.StartDate));
  //  this.CurrentEditCounsellingPalnRequest.EndDate = new Date(this.parserFormatter.format(this.EndDate));
  //    //this.CurrentSaveCounsellingPlanRequest.RecommendedPackage = this.Recomm
  //    //this.CurrentSaveCounsellingPlanRequest.CounsellingDoctor = this.Doctor;
  //    //this.CurrentSaveCounsellingPlanRequest.SelectEmi = this.SelectEmi;
  //    //this.CurrentSaveCounsellingPlanRequest.FinancialStatus = this.FinancialStatus;
  //    //this.CurrentSaveCounsellingPlanRequest.Remarks = this.AddRemarks;
  //    //this.CurrentSaveCounsellingPlanRequest.Concerns = this.Concerns;
  //    //this.CurrentSaveCounsellingPlanRequest.TreatmentPlan;
  //    //this.CurrentSaveCounsellingPlanRequest.StartDate;
  //    //this.CurrentSaveCounsellingPlanRequest.RecommendedPackage;
  //    //this.CurrentSaveCounsellingPlanRequest.CounsellingDoctor;
  //    //this.CurrentSaveCounsellingPlanRequest.PackageCost;
  //    //this.CurrentSaveCounsellingPlanRequest.SelectEmi;
  //    //this.CurrentSaveCounsellingPlanRequest.FinancialStatus;

  //    //this.CurrentSaveCounsellingPlanRequest.Concerns;
  //  this.CurrentEditCounsellingPalnRequest.Remarks = "";
  //    //this.CurrentSaveCounsellingPlanRequest.Potential;
  //  this.CurrentEditCounsellingPalnRequest.ConditionalOperator = 20;
  //    //this.CurrentSaveCounsellingPlanRequest.CounsellingDoctor = "";
  //  //this.CurrentEditCounsellingPalnRequest.CounsellingPlanCode = "";
  //    //this.CurrentSaveCounsellingPlanRequest.PlanStatus = "Created";
  //    //this.CurrentSaveCounsellingPlanRequest.Potential = "";
  //    //this.CurrentSaveCounsellingPlanRequest.TreatmentPlan = "";
  //  this.CurrentEditCounsellingPalnRequest.VisitCode = "";


  //  this.actorservice.SaveCounsellingPlan(this.CurrentEditCounsellingPalnRequest)
  //      .subscribe((result) => {
  //        this.ApiResData = result;
  //        if (!this.ApiResData.hasError) {

  //          if (this.ApiResData.Result > 0) {
  //            //this.GetActorEducationInfoController();
  //            //this.GetResourceIdentificationByDateInfoController();
  //            // alertFunctions.AlertParam('Saved Successfully.....!');
  //            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

  //            this.activeModal.close();

  //            this.stopRefreshing();
  //          }
  //          else {
  //            alertFunctions.AlertParam("Invalid Operation...!");


  //            this.stopRefreshing();

  //          }

  //        }
  //        else {
  //          this.stopRefreshing();
  //          if (this.ApiResData.ErrorData != "") {

  //            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



  //          }
  //          else {
  //            this.stopRefreshing();
  //            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

  //          }
  //        }

  //      },


  //        (error) => {

  //          if (error == "401 - Unauthorized") {
  //            alertFunctions.AlertParamEr(error);

  //            this.stopRefreshing();



  //          }
  //          else {
  //            alertFunctions.AlertParamEr(error);

  //            this.stopRefreshing();
  //          }
  //        }
  //      );

   
  //}
}





  //GetActorDocController() {
  //  this.StartRefreshing();
  //  this.docservice.GetActorDocController(this.CurrentActorDocRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.CurrentActorDocController = this.ApiResData.Result;
  //        this.initGridButton();
  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //    (error) => {

  //      if (error == "401 - Unauthorized") {
  //        alertFunctions.AlertParamEr(error);
  //        this.stopRefreshing();



  //      }
  //      else {
  //        alertFunctions.AlertParamEr(error);
  //        this.stopRefreshing();
  //      }
  //    }


  //    );

  //}

  

  /////////////////////////



  //

  // https://www.codeproject.com/Articles/1195569/Angular-Data-Grid-with-Sorting-Filtering-Export-to
  // dbops: DBOperation;
  //Grid Vars start














  /////////////////////////

